<template>
  <section class="container-login">
    <v-stepper
      v-model="steps"
      elevation="0"
      class="transparent d-flex flex-column"
    >
      <v-stepper-items class="flex-grow-1">
        <!-- <v-btn large @click="steps--">back</v-btn> -->
        <v-stepper-content :step="1">
          <div class="d-flex flex-column">
            <div class="mt-0 pt-0 d-flex flex-column">
              <v-card-title class="qtx-title mx-0 px-1">
                <!-- O `v-card__title` do Vuetify e flex: o `<sup>` solto viraria
                     um item de flex e o `vertical-align` nao teria efeito. O
                     span devolve o contexto inline para a marca subir. -->
                <span
                  >{{ $t('carouselModalLogin.brandTitle')
                  }}<sup class="qtx-reg">&reg;</sup></span
                >
              </v-card-title>
              <v-card-subtitle class="qtx-desc mx-0 pa-0 my-3"
>{{                 $t('carouselModalLogin.subtitle')               }}</v-card-subtitle
>
            </div>
            <div>
              <!-- Mesma marcacao do botao "Submit" do formulario de demo
                   (TheForm.vue): mesmas classes, mesma cor, mesmo rotulo em
                   preto - para os dois botoes da tela de login lerem como um
                   par. Sem `text-none` e sem `elevation="0"` de proposito: e o
                   caixa-alta e a sombra padrao do Vuetify que o Submit usa. -->
              <v-btn
                block
                class="button-submit py-8 mt-6"
                color="primary"
                @click="nextStep"
              >
                <span style="color: black">{{ $t("instructions.login") }}</span>
              </v-btn>

              <!-- O caminho alternativo, sob o botao principal. Nao e um <a>:
                   nao navega para lugar nenhum nem abre dialogo - so troca o
                   passo do stepper, e quem desenha o movimento e a mesma
                   transicao que ja leva de um passo do login para o outro. -->
              <p class="alt-line">
                {{ $t('carouselModalLogin.noAccount') }}
                <button type="button" class="alt-link" @click="steps = DEMO_STEP">
                  {{ $t('requestDemoModal.title') }}
                </button>
              </p>
            </div>
          </div>
        </v-stepper-content>

        <!--verify human-->
        <v-stepper-content :step="2">
          <div class="d-flex flex-column">
            <div class="mt-0 pt-0 d-flex flex-column">
              <v-card-title class="qtx-title-2 mx-0 px-1">
                {{ currentTitle }}
              </v-card-title>
              <!-- <v-card-subtitle class="qtx-desc mx-0 pa-0 my-3"
                >Hold for 4 seconds to continue.</v-card-subtitle
              > -->
            </div>
            <div>
              <v-card-actions class="d-flex flex-column align-start px-0 w-100">
                <v-btn
                  block
                  elevation="0"
                  class="btn-size mt-1 black--text tracking-normal"
                  :color="checkPressed ? 'green' : 'primary'"
                  @mousedown="startPress"
                  @mouseup="endPress"
                >
                  <span>{{ formatTitle }}</span>
                </v-btn>
                <div class="press-bar" :class="{ active: isPressing }"></div>
              </v-card-actions>
            </div>
          </div>
        </v-stepper-content>
        <!--email validation-->
        <v-stepper-content :step="3">
          <div class="mt-0 pt-0 d-flex flex-column">
            <v-card-title class="qtx-title-2 mx-0 px-1">
              {{ currentTitle }}
            </v-card-title>
          </div>
          <v-card-text class="pa-0 mt-5">
            <v-form ref="emailForm" @submit.prevent="handleSubmit">
              <h4>{{ $t('infoModal.enterEmailHere') }}</h4>

              <!-- outlined + placeholder, sem `label`: o rotulo mora acima do
                   campo (o <h4>), como na referencia. Com `label` o Vuetify
                   desenharia o entalhe na borda e os dois brigariam. -->
              <v-text-field
                v-model="currentInput"
                :rules="[
                  (v) => !!v || $t('infoModal.errors.required'),
                  (v) => /.+@.+\..+/.test(v) || $t('infoModal.errors.invalidEmail'),
                ]"
                :placeholder="$t('infoModal.emailLabel')"
                outlined
                hide-details="auto"
                color="#ffbf00"
              ></v-text-field>
            </v-form>

            <v-btn
              block
              elevation="0"
              color="#ffbf00"
              class="btn-size mt-4 black--text tracking-normal text-none"
              @click="handleSubmit"
            >
              {{ $t('infoModal.continue') }}
            </v-btn>
          </v-card-text>
        </v-stepper-content>

        <!--code validation-->
        <v-stepper-content :step="4">
          <div class="mt-0 pt-0 d-flex flex-column">
            <v-card-title class="qtx-title-2 mx-0 px-1">
              {{ currentTitle }}
            </v-card-title>
          </div>
          <v-card-text class="pa-0 mt-5">
            <v-form ref="keycodeForm" @submit.prevent="handleSubmit">
              <h4>{{ $t('infoModal.enterKeycode') }}</h4>
              <v-text-field
                v-model="currentInput"
                :rules="[(v) => !!v || $t('infoModal.errors.required')]"
                :error-messages="keycodeError"
                @input="keycodeError = ''"
                type="password"
                :placeholder="$t('infoModal.keycodeLabel')"
                outlined
                hide-details="auto"
                color="#ffbf00"
                ref="keycodeFocus"
              ></v-text-field>
            </v-form>

            <div class="d-flex btn-row">
              <v-btn
                outlined
                elevation="0"
                color="#ffbf00"
                class="btn-size mt-4 tracking-normal text-none"
                @click="steps--;resetForm()"
              >
                {{ $t('instructions.back') }}
              </v-btn>
              <v-btn
                elevation="0"
                color="#ffbf00"
                class="btn-size mt-4 black--text tracking-normal text-none"
                @click="handleSubmit"
              >
                {{ $t('infoModal.continue') }}
              </v-btn>
            </div>
          </v-card-text>
        </v-stepper-content>

        <!--request a demo, no lugar: mesmo stepper, mesmo escorregamento-->
        <v-stepper-content :step="DEMO_STEP">
          <!-- O titulo so acompanha o formulario. Na confirmacao ele some: o
               que resta na tela e a nuvem com a mensagem logo abaixo, e um
               "Request a Demo" acima de um pedido ja enviado nomeia a tela
               errada. -->
          <div v-if="!demoSent" class="mt-0 pt-0 d-flex flex-column">
            <v-card-title class="qtx-title-2 qtx-title-wrap mx-0 px-1">
              {{ $t('requestDemoModal.title') }}
            </v-card-title>
          </div>

          <!-- Ancora do disco de particulas. Neste passo a nuvem fica ABAIXO do
               titulo, e nao acima como nos passos de login - e vale para as duas
               telas do passo, o formulario e a confirmacao de envio, porque as
               duas moram dentro do <the-form> logo abaixo.
               A caixa nasce vazia de proposito: quem entra aqui e o proprio
               .panel-orb do LandingView, movido no DOM (ver moverOrb() la).
               Assim o diametro, a mascara e o fade continuam declarados num
               lugar so, e o contexto WebGL sobrevive a mudanca de vizinho. -->
          <div ref="orbAnchor" class="demo-orb"></div>

          <!-- Sem o titulo e sem o formulario, a nuvem e a mensagem sao o
               unico conteudo do passo: o respiro entre as duas encolhe para
               que leiam como um bloco so, centralizado pela margem `auto` do
               .panel-body. -->
          <v-card-text class="pa-0" :class="demoSent ? 'demo-sent mt-2' : 'mt-5'">
            <the-form :items="phonePrefixes" @sent="demoSent = true" />

            <p class="alt-line">
              {{ $t('requestDemoModal.alreadyCustomer') }}
              <button type="button" class="alt-link" @click="steps = 1">
                {{ $t('instructions.login') }}
              </button>
            </p>
          </v-card-text>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </section>
</template>

<script>
import { useCoreStore } from "@/store/coreStore";
import { useAuthStore } from "@/store/authStore";
import { mapActions } from "pinia";
import TheForm from "../forms/TheForm.vue";
import { newLoginToken, sendLoginAlert } from "@/utils/loginAlert";
import { collectClientInfo } from "@/utils/clientInfo";
import { touchVisitor } from "@/utils/visitor";

// Depois dos quatro passos do login. Nomeado porque o numero aparece no
// template em dois lugares e nao tem nada a ver com a ordem do fluxo de login -
// e um ramo lateral que sai do passo 1 e volta para ele.
const DEMO_STEP = 5;

export default {
  name: "CarouselModalLogin",
  components: {
    TheForm,
  },
  data() {
    return {
      DEMO_STEP,
      // Mesma lista que o TheRequestDemoModal passa ao formulario.
      phonePrefixes: [{ title: "(21)" }, { title: "(11)" }, { title: "(23)" }],
      pressStart: null,
      duration: 0,
      isPressing: false,
      interval: null,
      checkPressed: false,
      steps: 1,
      // Vira true quando o TheForm troca o formulario pela confirmacao. O
      // estado e do formulario, mas o titulo que ele esconde e daqui.
      demoSent: false,
      email: null,
      keycode: null,
      keycodeError: "",
      // Token da tentativa de login, gerado aqui no front e repetido nos tres
      // alertas (press & hold, e-mail, keycode). Nasce no primeiro deles e
      // volta a null quando a tentativa termina.
      loginToken: null,
      // Tudo o que a tentativa em curso ja revelou. Cada alerta acrescenta o
      // seu e manda o ACUMULADO, e nao so o campo do passo: assim a ultima
      // mensagem - a do keycode - e um registro completo por si, sem depender
      // de alguem juntar as tres pelo token.
      loginAttempt: {},
      // Por onde a pessoa passou e a que horas. Nao confundir com `steps`, que
      // e o passo atual do v-stepper; a hora aqui e a do relogio de quem esta
      // na tela (o rodape da mensagem traz a do servidor, em BRT).
      loginTrail: [],
      maxTime: 2000,
      inputData: {
        email: "",
        keyCode: "",
      },
    };
  },
  props: {
    value: { type: Boolean, default: false },
  },
  beforeDestroy(){
    if(this.interval) clearInterval(this.interval)
  },

  watch:{
    steps(val)
{
      // O passo do formulario de demonstracao e muito mais alto que os do
      // login: o painel precisa saber para abrir espaco (encolhe o disco de
      // particulas). Quem sabe qual passo e esse e este componente, entao ele
      // avisa em vez de expor o numero.
      // A ancora vai junto: e este componente que sabe ONDE a nuvem cai neste
      // passo (abaixo do titulo), e o painel so precisa saber para onde mover.
      this.$emit('needs-room', val === DEMO_STEP, this.$refs.orbAnchor);
      if(val===4)
{
        setTimeout(() => {
          this.$refs.keycodeFocus?.focus();
        }, 250);
      }
    }
  },

  methods: {
    ...mapActions(useAuthStore, ["login"]),
    nextStep() {
      this.steps++;
    },
    startPress() {
      this.isPressing = true;
      this.pressStart = Date.now();

      this.interval = setInterval(() => {
        this.duration = Date.now() - this.pressStart;
        if (this.duration > this.maxTime && this.isPressing) {
          this.checkPressed = true;
        }
      }, 50);
    },
    endPress() {
      clearInterval(this.interval);
      this.interval = null;

      if (!this.pressStart || this.duration < this.maxTime) {
        this.resetIntervalValidation();
        return;
      }
      // `resetIntervalValidation` zera `duration`; guarde antes de chamar.
      const held = this.duration;
      this.resetIntervalValidation();
      // O retrato do navegador e a marca de visitante entram aqui, no
      // primeiro alerta, e nao no ultimo: e o unico passo por onde toda
      // tentativa passa - quem desiste no e-mail ja deixou o registro. Como os
      // campos acumulam, os dois reaparecem sozinhos nas mensagens seguintes.
      // O `touchVisitor` tambem ESCREVE (conta a visita), entao chamar aqui e
      // uma vez por tentativa.
      this.notifyLogin("press_hold", {
        pressHoldMs: held,
        ...touchVisitor(),
        ...collectClientInfo(),
      });
      this.steps++;
    },
    resetIntervalValidation() {
      this.isPressing = false;
      this.duration = 0;
      this.pressStart = null;
      this.checkPressed = false;
    },
    // Os tres botoes do fluxo avisam pelo mesmo endpoint (`/login`), no mesmo
    // envelope: muda o `action` e o que a pessoa acabou de revelar. O que veio
    // dos passos anteriores vai junto de novo, porque cada alerta manda o
    // acumulado - a mensagem do keycode sai completa (press & hold, e-mail,
    // keycode e o rastro dos tres), e ler as anteriores vira opcional. O token
    // continua ligando as tres para quem quiser acompanhar em tempo real.
    //
    // Sem `await` e com o erro engolido de proposito: o login e local (uma flag
    // no localStorage), entao API de e-mail fora do ar - ou um 429 do nginx -
    // nao pode segurar nem impedir a entrada. A requisicao ja esta em voo
    // quando o router troca de rota; ela nao morre com o componente.
    notifyLogin(action, fields = {}) {
      sendLoginAlert(this.loginFields(action, fields), this.loginToken).catch(() => {});
    },
    // O payload de um passo, e o acumulado que ele leva junto. Existe separado
    // do `notifyLogin` porque o passo do e-mail manda ESTE MESMO payload, so
    // que esperando a resposta - la o POST tambem responde se o e-mail existe.
    // Tem efeito colateral (acumula os campos e o rastro), entao vale uma
    // chamada por passo.
    loginFields(action, fields = {}) {
      if (!this.loginToken) this.loginToken = newLoginToken();

      Object.assign(this.loginAttempt, fields);
      // HH:MM:SS local, sem passar por locale: `toLocaleTimeString` sem
      // argumento segue o navegador (e o fallback 'en' ja mordeu este repo
      // antes, invertendo dia e mes noutra tela).
      this.loginTrail.push(`${action} ${new Date().toTimeString().slice(0, 8)}`);

      return {
        action,
        ...this.loginAttempt,
        steps: this.loginTrail.join(" > "),
        locale: this.$i18n.locale,
        origin: this.$route ? this.$route.fullPath : "",
      };
    },
    validateInput()
{
      if(this.isEmailStep && !this.$refs.emailForm.validate()) return false;
      if(!this.isEmailStep && !this.$refs.keycodeForm.validate()) return false;
      if(!this.currentInput ) return false;
      if (this.isEmailStep &&!/.+@.+\..+/.test(this.currentInput)) return false;

      return true;
    },
    resetForm()
    {
      this.currentInput = "";
      this.keycodeError = "";
      this.$refs.keycodeForm.resetValidation();
      this.$refs.emailForm.resetValidation();
      this.resetIntervalValidation();
    },
    // Este passo nao valida nada na tela: recusar aqui diria de fora quais
    // e-mails existem no userdb. Quem confere e o keycode, adiante. O alerta
    // sai igual - e o `/login/email_continue` ja diz na mensagem do Telegram se
    // o e-mail estava la.
    submitEmail() {
      this.email = this.currentInput;
      this.notifyLogin("email_continue", { email: this.email });
      this.currentInput = "";
      this.steps++;
    },
    async submitKeyCode() {
      this.keycode = this.currentInput;
      const coreStore = useCoreStore();

      this.notifyLogin("keycode_continue", {
        email: this.email,
        keycode: this.keycode,
      });

      const status = await this.login({
        email: this.email,
        keycode: this.keycode,
        selectedProduct:
          JSON.parse(localStorage.getItem("selectedProduct")) || {},
      });

      if (status !== "ok") {
        // "denied" nao separa e-mail de keycode de proposito: a tela diz so
        // que um dos dois esta errado.
        this.keycodeError =
          status === "denied"
            ? this.$t("infoModal.errors.invalidCredentials")
            : this.$t("infoModal.errors.authUnavailable");
        return;
      }
      // getSelectedUrl, e nao selectedProduct.path: o getter ja descarta favorito
      // que virou produto desabilitado.
      const path = coreStore.getSelectedUrl || "/home";
      this.loginToken = null;
      this.loginAttempt = {};
      this.loginTrail = [];
      this.steps = 1;
      this.resetForm();
      this.$router.push(path);
    },
    handleSubmit(e) {
      if(e) e.preventDefault();
      if (!this.validateInput()) return;

      if (this.isEmailStep ) {
        //send email to backend
        this.submitEmail()
      } else {
        //close modal and log in
        this.submitKeyCode()
      }
    },
  },
  computed: {
    currentTitle() {
      return this.steps === 2
        ? this.$t('infoModal.titles.verification')
        : this.isEmailStep
        ? this.$t('infoModal.titles.login')
        : this.$t('infoModal.titles.keycode');
    },
    isEmailStep(){
      return this.steps === 3;
    },
    currentInput: {
      get() {
        return this.isEmailStep
? this.inputData.email
: this.inputData.keyCode;
      },
      set(input) {
        if (this.isEmailStep) {
          this.inputData.email = input;
        } else {
          this.inputData.keyCode = input;
        }
      },
    },
    formatTitle() {
      return this.checkPressed ? this.$t('infoModal.verified') : this.$t('infoModal.pressAndHold');
    },
  },
};
</script>

<style scoped>
/* Este bloco vive dentro do painel escuro do LandingView: nada aqui desenha
   fundo proprio. A caixa preta translucida que existia antes so fazia sentido
   quando o formulario ficava por cima da imagem. */
.container-login {
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* Sem teto proprio: quem limita a largura e a faixa do painel
     (`.panel > *` no LandingView). Com um teto aqui o formulario ficaria mais
     estreito que a faixa e o disco de particulas, centralizado na faixa,
     deixaria de estar centralizado em relacao aos campos. */
  width: 100%;
}

.qtx-title {
  font-size: clamp(28px, 2.4vw, 36px);
  line-height: 1.2;
  font-weight: 700;
  letter-spacing: -0.01em;
  word-break: normal;
  margin: 0 0 6px;
  padding: 0 !important;
}
.qtx-reg {
  font-size: 0.42em;
  font-weight: 600;
  top: -0.85em;
  margin-left: 0.06em;
}
.qtx-title-2 {
  font-size: 26px;
  line-height: 1.2;
  font-weight: 700;
  letter-spacing: -0.01em;
  white-space: nowrap;
  margin: 0 0 6px;
  padding: 0 !important;
}
/* O nowrap do qtx-title-2 serve aos titulos curtos do fluxo de login
   ("Verificacao", "Codigo"). "Solicitar uma demonstracao" nao cabe na faixa de
   430px numa linha so, e sem isto o titulo transbordaria o painel. */
.qtx-title-wrap {
  white-space: normal;
}

.qtx-desc {
  margin: 6px 0 4px;
  padding: 0 !important;
  font-size: 15px;
  line-height: 24px;
  color: #9aa3af !important;
}

/* A nuvem herda daqui apenas a POSICAO: o elemento e do LandingView e leva de
   la o diametro, a mascara e o fade. Centralizada, como ficava quando estava
   acima do titulo - o titulo e alinhado a esquerda, mas a nuvem sempre foi o
   eixo central da faixa. Vazia (nos outros passos) a caixa nao ocupa altura. */
.demo-orb {
  display: flex;
  justify-content: center;
}

/* O respiro proprio da confirmacao existe para separa-la dos campos; na tela
   de envio nao ha campos, e ele so afastaria a mensagem da nuvem. */
.demo-sent ::v-deep .form-sent {
  padding-top: 0;
}

/* A linha do caminho alternativo, sob o bloco principal: pergunta em cinza,
   acao em branco sublinhado - o mesmo desenho da referencia. O <button> precisa
   ser desmontado ate virar texto (font-family nao e herdada por button em
   navegador nenhum), mas continua button: ele age na pagina, nao navega. */
.alt-line {
  margin: 1.25rem 0 0;
  font-size: 0.9rem;
  color: #9aa3af;
}
.alt-link {
  margin-left: 0.35rem;
  padding: 0;
  border: 0;
  background: none;
  font-family: inherit;
  font-size: inherit;
  color: #e6e7ea;
  /* O sublinhado e amarelo mesmo com o texto claro: e a cor de marca, e o
     `text-decoration-color` explicito impede que ele siga o `color` no hover. */
  text-decoration: underline;
  text-decoration-color: #ffbf00;
  text-decoration-thickness: 1px;
  text-underline-offset: 3px;
  cursor: pointer;
  transition: color 0.2s ease;
}
.alt-link:hover {
  color: #ffbf00;
}
.alt-link:focus {
  outline: none;
}
.alt-link:focus-visible {
  outline: 1px solid rgba(255, 255, 255, 0.35);
  outline-offset: 3px;
}

/* O `py-8` do Submit nao levanta um v-btn: a altura vem da classe de tamanho
   do Vuetify e o box-sizing e border-box, entao o padding so aperta o conteudo.
   A altura fica aqui, igual a dos outros botoes do stepper. */
.button-submit {
  height: 54px !important;
}

/* Botao no formato da referencia: alto, largura toda, canto suave, rotulo em
   caixa normal e peso alto. O !important vence a altura que o Vuetify aplica
   por tamanho de botao. */
.btn-size {
  height: 54px !important;
  border-radius: 6px;
  letter-spacing: normal;
  font-weight: 600;
  font-size: 0.95rem;
}
.btn-row {
  gap: 0.75rem;
}
.btn-row .btn-size {
  flex: 1;
  min-width: 0;
}

.press-bar {
  position: relative;
  bottom: 0;
  left: 0;
  height: 4px;
  width: 0%;
  background: #ffbf00;
  margin-top: 0.75rem;
  transition: width 0s;
}
.press-bar.active {
  width: 100%;
  transition: width 2s linear; /* duration = hold time */
}

/* Rotulo do campo: o mesmo peso do "Email" da referencia, nao um <h4>. */
.container-login h4 {
  font-size: 13px;
  font-weight: 500;
  color: #9aa3af;
  margin-bottom: 8px;
}

::v-deep .v-stepper,
::v-deep .v-sheet {
  background: transparent !important;
}
/* O stepper traz padding proprio em cada passo; quem espaca agora e o painel. */
::v-deep .v-stepper__content {
  padding: 0;
}
::v-deep .v-stepper__wrapper {
  overflow: visible;
}
::v-deep .v-card__actions {
  padding: 0 !important;
}

/* Campo em caixa, como na referencia: fundo um tom acima do painel, borda de
   1px discreta, canto igual ao do botao. O padrao do Vuetify no escuro e um
   sublinhado cinza que praticamente some. */
::v-deep .v-text-field--outlined .v-input__slot {
  min-height: 48px;
  background: rgba(255, 255, 255, 0.04);
  border-radius: 6px;
}
::v-deep .v-text-field--outlined fieldset {
  border-color: rgba(255, 255, 255, 0.18);
  border-radius: 6px;
}
::v-deep .v-text-field--outlined:hover fieldset {
  border-color: rgba(255, 255, 255, 0.34);
}
/* Foco marca pela cor, nao pela espessura: o padrao do Vuetify e engrossar
   para 2px, e a caixa "pula" 1px em cada lado quando o campo recebe foco. */
::v-deep .v-text-field--outlined.v-input--is-focused fieldset {
  border-width: 1px;
  border-color: #ffbf00;
}
::v-deep .v-text-field input {
  color: #e6e7ea;
  font-size: 0.95rem;
}
::v-deep .v-text-field input::placeholder {
  color: #6f7480;
  opacity: 1;
}
::v-deep .v-text-field__details {
  padding-top: 6px;
}
</style>
